var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMasteringTab = function SvgMasteringTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.418v9.167M15.584 9.168v3.667M6.416 8.25v5.5",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.834 10.999c0-4.322 0-6.482 1.342-7.825C4.52 1.832 6.68 1.832 11.001 1.832c4.32 0 6.482 0 7.824 1.342 1.342 1.343 1.342 3.503 1.342 7.825 0 4.32 0 6.481-1.342 7.824-1.342 1.342-3.503 1.342-7.824 1.342-4.322 0-6.482 0-7.825-1.342-1.342-1.343-1.342-3.503-1.342-7.824Z",
    stroke: "currentColor",
    strokeWidth: 1.75
  })));
};
export default SvgMasteringTab;